import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// rutas
import { APP_ROUTES } from './app.routes';

// servicios
import { ServiceModule } from './services/service.module';
import { SharedModule } from './shared/shared.module';

// componentes
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './login/register.component';
import { CookieService } from 'ngx-cookie-service';

// notificaciones
//import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
//const config: SocketIoConfig = { url: 'http://nutriser-backend.herokuapp.com:55353', options: {} };
//const config: SocketIoConfig = { url: 'http://localhost:8000', options: {} };

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    RegisterComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTES,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ServiceModule,
    SharedModule,
    //SocketIoModule.forRoot(config),
  ],
    
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
